<template>
  <div>
    <!-- ACQUEREUR / CO ACQUEREUR -->
    <div
      class="is-flex"
      style="flex: 1 auto; width: 100%">
      <template v-for="(buyer, index) in buyers">
        <div
          :key="index"
          style="width: 100%"
          class="is-flex has-background-light"
          :class="index > 0 ? 'is-border-right is-border-top is-border-bottom' : 'is-border'">
          <div
            style="width: 100%;"
            class="is-column is-padding is-column">
            <div
              class="is-column is-padding-bottom"
              style="gap: 5px; width: 100%">
              <r-label
                v-if="index > 0"
                :label="'RÉSERVATAIRE / CO-Acquéreur'"
                :is-required="false"></r-label>
              <r-label
                v-else
                :label="'RÉSERVATAIRE / Acquéreur'"
                :is-required="false"></r-label>
              <div
                class="is-uppercase has-text-weight-bold"
                v-if="buyer.first_name && buyer.last_name">
                {{ buyer.last_name }} <span style="is-uppercase">{{ buyer.first_name }}</span>
              </div>
            </div>
            <div
              class="is-column is-padding-bottom"
              style="gap: 5px; width: 100%">
              <r-label
                :label="'Adresse'"
                :is-required="false"></r-label>
              <div
                class="title is-5 has-text-weight-medium is-uppercase has-text-weight-bold"
                v-if="buyer && buyer.address">
                <span
                  v-if="buyer.address.line1"
                  class="is-break-word">{{ buyer.address.line1 }}</span>&nbsp;
                <span v-if="buyer.address.zip_code || buyer.address.city">{{ buyer.address.zip_code }} {{ buyer.address.city }}</span>
                <span v-if="buyer.address.country">{{ buyer.address.country }}</span>
                <span
                  v-if="!buyer.address.line1 && !buyer.address.zip_code &&
                    !buyer.address.country && !buyer.address.city">
                  NC
                </span>
              </div>
            </div>
            <div
              class="is-flex">
              <div
                class="is-column"
                style="gap: 5px; width: 50%">
                <r-label
                  :label="'Téléphone'"
                  :is-required="false"></r-label>
                <div class="title is-5 has-text-weight-medium has-text-weight-bold">
                  <phone-number
                    v-if="'phone' in buyer && buyer.phone"
                    :phone="buyer.phone"></phone-number>
                  <phone-number
                    v-else-if="'rep_phone' in buyer && buyer.rep_phone"
                    :phone="buyer.rep_phone"></phone-number>
                  <span v-else>
                    NC
                  </span>
                </div>
              </div>
              <div
                class="is-column"
                style="gap: 5px; width: 50%">
                <r-label
                  :label="'Email'"
                  :is-required="false"></r-label>
                <div class="title is-5 has-text-weight-medium has-text-weight-bold">
                  <span>{{ buyer.email || buyer.rep_email || 'NC' }}</span>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="!isPending"
            @click="localCurrentStep = 1; modifyStep()"
            style="justify-content: center; align-items: center"
            class="is-flex is-padding-xsmall is-border-left has-cursor-pointer">
            <i
              style="font-size: 1.5rem;"
              class="fas fa-pencil-alt"></i>
          </div>
        </div>
      </template>
    </div>
    <!-- NOTAIRE -->
    <div
      class="is-flex has-background-light is-border is-margin-top-xsmall"
      style="width: 100%">
      <div
        style="width: 100%;"
        class="is-column is-padding is-column">
        <div
          style="gap: 10px"
          class="is-flex is-nowrap is-padding-bottom">
          <div
            class="is-column"
            style="gap: 5px; width: 50%">
            <r-label
              :label="'Notaire de l\acquéreur'"
              :is-required="false"></r-label>
            <div class="title is-5 has-text-weight-medium has-text-weight-bold">
              <span v-if="reservation.notary_details.use_buyer_notary">
                {{ reservation.notary_details.name }}
              </span>
              <span v-else>
                NC
              </span>
            </div>
          </div>
          <div
            class="is-column"
            style="gap: 5px; width: 50%">
            <r-label
              :label="'Téléphone'"
              :is-required="false"></r-label>
            <div class="title is-5 has-text-weight-medium has-text-weight-bold">
              <span v-if="reservation.notary_details.use_buyer_notary">
                {{ reservation.notary_details.phone }}
              </span>
              <span v-else>
                NC
              </span>
            </div>
          </div>
          <div
            class="is-column"
            style="gap: 5px; width: 50%">
            <r-label
              :label="'Email'"
              :is-required="false"></r-label>
            <div class="title is-5 has-text-weight-medium has-text-weight-bold">
              <span v-if="reservation.notary_details.use_buyer_notary">
                {{ reservation.notary_details.email }}
              </span>
              <span v-else>
                NC
              </span>
            </div>
          </div>
        </div>
        <div
          class="is-column"
          style="gap: 5px; width: 50%">
          <r-label
            :label="'Adresse'"
            :is-required="false"></r-label>
          <div class="title is-5 has-text-weight-medium has-text-weight-bold">
            <span v-if="'address' in reservation.notary_details && reservation.notary_details.address && 'line1' in reservation.notary_details.address && 'city' in reservation.notary_details.address && 'zip_code' in reservation.notary_details.address && reservation.notary_details.address.zip_code && reservation.notary_details.address.city && reservation.notary_details.address.line1 ">
              {{ reservation.notary_details.address.line1 }} {{ reservation.notary_details.address.city }} {{ reservation.notary_details.address.zip_code }}
            </span>
            <span v-else>NC</span>
          </div>
        </div>
      </div>
      <div
        v-if="!isPending"
        @click="localCurrentStep = 1; modifyStep()"
        style="justify-content: center; align-items: center"
        class="is-flex is-padding-xsmall is-border-left has-cursor-pointer">
        <i
          style="font-size: 1.5rem;"
          class="fas fa-pencil-alt"></i>
      </div>
    </div>
    <!-- PRIX IMMO  -->
    <div
      class="is-flex has-background-light is-border is-margin-top-xsmall"
      style="width: 100%">
      <div
        style="width: 100%;"
        class="is-column is-padding is-column">
        <div
          class="is-column"
          style="gap: 5px; width: 100%">
          <span
            v-if="selectedPack === null"
            style="font-weight: 400"
            class="title is-3">Prix immo TTC : <span class="has-text-weight-bold">{{ reservation.sale_price_ttc }} €</span>
          </span>
          <div v-else-if="selectedPack">
            <span
              style="font-weight: 400"
              class="title is-3">Prix {{ selectedPack.name }} TTC : <span class="has-text-weight-bold">{{ selectedPack.sale_price_ttc }} €</span>
            </span>
            <div
              class="is-padding-top-small"
              style="width: 100%"
              v-if="selectedPack.description">
              <r-label
                :label="'Descriptif'"
                :is-required="false"></r-label>
              <b
                class="is-size-6 has-text-weight-bold is-uppercase"
                v-html="selectedPack.description"></b>
            </div>
          </div>
          <div v-if="isCheckParkingEmpty">
            <br>
            <span
              class="has-text-weight-bold">
              Incluant :
            </span>
            <br>
            <div
              v-for="(parking, idx) in parkings"
              :key="idx"
              class="is-column"
              style="gap: 5px; width: 100%">
              <span
                v-if="checkParking[parking.pk]"
                class="is-flex is-nowrap is-align-items-center">
                <b class="is-size-6">- {{ parking.nature | lotTypeLabel }}&nbsp;</b>
                <span
                  class="is-size-6"
                  v-for="(type, i ) in parking.parking_type"
                  :key="'type' + i">&nbsp;-&nbsp; {{ i > 0 ? ', ' : '' }}{{ type | lotSubtypeLabel }}&nbsp;</span>
                <span
                  class="is-size-6"
                  v-if="parking.info">&nbsp;({{ parking.info }})&nbsp;</span>
                <span
                  class="is-size-6"
                  v-for="(sale_mode, i ) in parking.sales_mode"
                  :key="'sale_mode' + i">&nbsp;{{ i > 0 ? ', ' : '' }}{{ sale_mode | salesmodeLabel }}&nbsp;</span>
                <span
                  class="is-size-6"
                  v-if="parking.sale_price_ttc">&nbsp;-&nbsp;{{ parking.sale_price_ttc }} €</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!isPending"
        @click="localCurrentStep = 2; modifyStep()"
        style="justify-content: center; align-items: center"
        class="is-flex is-padding-xsmall is-border-left has-cursor-pointer">
        <i
          style="font-size: 1.5rem;"
          class="fas fa-pencil-alt"></i>
      </div>
    </div>
    <!-- DONNEES PRE-RESA  -->
    <div
      class="is-flex has-background-light is-border is-margin-top-xsmall"
      style="width: 100%">
      <div
        style="width: 100%;"
        class="is-column is-padding is-column">
        <div
          style="gap: 10px"
          class="is-flex is-nowrap">
          <div
            class="is-column"
            style="gap: 5px; width: 50%">
            <r-label
              :label="'Destination'"
              :is-required="false"></r-label>
            <div class="title is-5 has-text-weight-medium has-text-weight-bold">
              <span v-if="reservation.destination">
                <span v-if="reservation.destination === 'secondary_residence'">Résidence secondaire</span>
                <span v-if="reservation.destination === 'main_residence'">Résidence principale</span>
                <span v-if="reservation.destination === 'invest'">Investissement</span>
                <span v-if="reservation.destination === 'other'">Autre</span>
              </span>
              <span v-else>
                NC
              </span>
            </div>
          </div>
          <div
            class="is-column"
            style="gap: 5px; width: 50%">
            <r-label
              :label="'Dispositif'"
              :is-required="false"></r-label>
            <div class="title is-5 has-text-weight-medium has-text-weight-bold">
              <span v-if="reservation.tax_dispositif">
                {{ reservation.tax_dispositif }}
              </span>
              <span v-else>
                NC
              </span>
            </div>
          </div>
          <div
            class="is-column"
            style="gap: 5px; width: 50%">
            <r-label
              :label="'Mandat de Gestion'"
              :is-required="false"></r-label>
            <div class="title is-5 has-text-weight-medium has-text-weight-bold">
              <span v-if="reservation.mandat_de_gestion === true">
                Oui
              </span>
              <span v-else-if="reservation.mandat_de_gestion === false">
                Non
              </span>
              <span v-else>
                NC
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!isPending"
        @click="localCurrentStep = 1; modifyStep()"
        style="justify-content: center; align-items: center"
        class="is-flex is-padding-xsmall is-border-left has-cursor-pointer">
        <i
          style="font-size: 1.5rem;"
          class="fas fa-pencil-alt"></i>
      </div>
    </div>
    <!-- FINANCEMENT -->
    <div
      class="is-flex has-background-light is-border is-margin-top-xsmall is-margin-bottom"
      style="width: 100%">
      <div
        style="width: 100%;"
        class="is-column is-padding is-column">
        <div class="is-padding-bottom-xsmall">
          <span class="has-text-weight-bold is-size-6">
            FINANCEMENT
          </span>
        </div>
        <div
          v-if="not_using_loan"
          class="is-fullwidth">
          <span class="title is-6 has-text-weight-medium has-text-weight-medium">LE RÉSERVATAIRE DÉCLARE NE PAS RECOURIR À UN OU PLUSIEURS PRÊT BANCAIRE</span>
        </div>
        <div
          v-else
          style="gap: 10px"
          class="is-flex is-nowrap">
          <div
            class="is-column"
            style="gap: 5px; width: 50%">
            <r-label
              :label="'Banque'"
              :is-required="false"></r-label>
            <div class="title is-5 has-text-weight-medium has-text-weight-bold">
              <span v-if="reservation.funding_data.initial_bank_name && !not_using_loan">
                {{ reservation.funding_data.initial_bank_name }}
              </span>
              <span v-else>
                NC
              </span>
            </div>
          </div>
          <div
            class="is-column"
            style="gap: 5px; width: 50%">
            <r-label
              :label="'Montant max du prêt'"
              :is-required="false"></r-label>
            <div class="title is-5 has-text-weight-medium has-text-weight-bold">
              <span v-if="reservation.funding_data.initial_loan_value && !not_using_loan">
                {{ reservation.funding_data.initial_loan_value }}
              </span>
              <span v-else>
                NC
              </span>
            </div>
          </div>
          <div
            class="is-column"
            style="gap: 5px; width: 50%">
            <r-label
              :label="'Montant de l\'apport'"
              :is-required="false"></r-label>
            <div class="title is-5 has-text-weight-medium has-text-weight-bold">
              <span v-if="reservation.funding_data.contribution_amount && !not_using_loan">
                {{ reservation.funding_data.contribution_amount }}
              </span>
              <span v-else>
                NC
              </span>
            </div>
          </div>
          <div
            class="is-column"
            style="gap: 5px; width: 50%">
            <r-label
              :label="'Taux d\'intêret max'"
              :is-required="false"></r-label>
            <div class="title is-5 has-text-weight-medium has-text-weight-bold">
              <span v-if="reservation.funding_data.initial_loan_rate && !not_using_loan">
                {{ reservation.funding_data.initial_loan_rate }} %
              </span>
              <span v-else>
                NC
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!isPending"
        @click="localCurrentStep = 3; modifyStep()"
        style="justify-content: center; align-items: center"
        class="is-flex is-padding-xsmall is-border-left has-cursor-pointer">
        <i
          style="font-size: 1.5rem;"
          class="fas fa-pencil-alt"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { DefaultValues } from '@/mixins'

export default {
  name: 'ValidationPreResa',
  mixins: [DefaultValues],
  props: {
    buyers: {
      type: Array,
      required: true
    },
    selectedPack: {
      required: true
    },
    reservation: {
      type: Object,
      required: true
    },
    checkParking: {
      required: true
    },
    parkings: {
      type: Array,
      required: true
    },
    currentStep: {
      type: Number,
      required: true
    },
    not_using_loan: {
      validator (value) {
        return typeof value === 'boolean' || value === null
      },
      required: true
    }
  },
  data () {
    return {
      localCurrentStep: this.currentStep
    }
  },
  computed: {
    isPending () {
      return this.reservation.status === 'pending'
    },
    isCheckParkingEmpty () {
      if (Object.keys(this.checkParking).length !== 0) {
        const allTrue = Object.values(this.checkParking).every(value => value === true)
        return allTrue
      } else {
        return false
      }
    }
  },
  watch: {
    currentStep (newValue) {
      this.localCurrentStep = newValue
    }
  },
  methods: {
    modifyStep () {
      this.$emit('update:currentStep', this.localCurrentStep)
    },
    checkFinancementEmpty () {
      if (!this.reservation.funding_data.initial_loan_value && !this.reservation.funding_data.contribution_amount && !this.reservation.funding_data.initial_loan_value) {
        return true
      }
    }
  }
}
</script>
